import API_SERVICES from 'constants/app.constants'
import { isEmpty } from 'lodash'
import moment from 'moment'
import React from 'react'
import { Card, CardBody, CardHeader, CardText, CardTitle, Col, Row } from 'reactstrap'
import NoDataComponent from '../NoDataComponent'
const EntityDirectorInformation = ({data}) => {
    return (
        <React.Fragment>

            <Card style={{border:"none"}}>
                <CardHeader>
                    <div className="d-flex align-items-end">
                        <h4>Directors & Promoters</h4>
                    </div>
                </CardHeader>
                <CardBody className='m-0 p-0'>
                <Row>
                    {!isEmpty(data) ? data.map((item, index) => {
                        return (
                            <Col key={item.id} sm={4} className=''>
                            <div className='border' >
                                <CardBody className='d-flex align-items-center'>
                                    <span className='rounded-circle p-3 border border-3' >{item.avatar}</span>
                                    <div className='ps-2'>
                                        <CardTitle className="mb-1">{item.name} {" "} ({item.designation})</CardTitle>
                                        <CardText className="ms-0">{!isEmpty(item.dateOfAppointment) ? moment(item.dateOfAppointment).format('MMM DD, YYYY') : API_SERVICES.EMPTY_VALUE}</CardText>
                                    </div>
                                </CardBody>
                            </div>
                            </Col>
                        )
                    }) : <Col sm={12} className=''>
                    <NoDataComponent title='No Data' subtitle='No Data Available' />
                 </Col>}
                </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default EntityDirectorInformation